import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'

export const Collapsible = (props: React.ComponentProps<typeof CollapsiblePrimitive.Root>) => (
  <CollapsiblePrimitive.Root data-slot='collapsible' {...props} />
)
